import { render, staticRenderFns } from "./DataFastCallback.vue?vue&type=template&id=0169b617&scoped=true"
import script from "./DataFastCallback.vue?vue&type=script&lang=js"
export * from "./DataFastCallback.vue?vue&type=script&lang=js"
import style0 from "./DataFastCallback.vue?vue&type=style&index=0&id=0169b617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169b617",
  null
  
)

export default component.exports